import React, { Component } from 'react'
import ReactDOM from 'react-dom';
import './index.css';
//import App from './App';
import registerServiceWorker from './registerServiceWorker';
import 'semantic-ui-css/semantic.min.css';


//import _ from 'lodash'

import { Grid, Responsive} from 'semantic-ui-react'

import ThreeHeader from "./header/Header.js";
import MenuButtonBar from './assets/component/menuButton.jsx';
import AccorddinPannel from './assets/component/accorddinPannel.jsx';
import SocialButton from "./assets/component/socialButton.jsx";
import TabContent from "./assets/component/tabContent.jsx";
import MenuButtonOverlay from "./assets/component/menuButtonOverlay.jsx";

export default class StickyLayout extends Component {
  constructor(props) {
      super(props);
      this.state = {
        langactive:'en',
        menuactive:'about',
        resize: false,
      };
   }

  listenLANG = (name)=>{
    this.setState({ langactive: name });
  }
  
  listenMBB = (name)=>{
    this.setState({ menuactive: name });
  }

  handleOnUpdate = (e, { width }) => {
    if (width<1280){
      this.setState({ resize: true });
    }else{
      this.setState({ resize: false });
    }
  }

  render() {
    const fontStyle = {
      fontFamily: 'fantasy!important',
    };
    const mainStyle= {
      margin: '0 -1em 0 -1em'
    }
    return (
      <Responsive
        as={Grid}
        center
        fireOnMount
        onUpdate={this.handleOnUpdate}
        style={mainStyle}
      >

        <MenuButtonBar style={fontStyle} listenMBB={this.listenMBB} listenLANG={this.listenLANG} resize={this.state.resize}/>
        <ThreeHeader style={fontStyle} menuactive={this.state.menuactive}/>
        <TabContent style={fontStyle} menuactive={this.state.menuactive} langactive={this.state.langactive}  resize={this.state.resize}/>
      </Responsive>
    )
  }
}

ReactDOM.render(<StickyLayout />, document.getElementById('root'));
registerServiceWorker();



// WEBPACK FOOTER //
// ./src/index.js